import styled from 'styled-components'

const StyledCart = styled.div`
  .cart-items {
    display: grid;
    grid-gap: 10px;
    padding: 0;
    list-style-type: none;
  }

  .cart-total {
    width: 100%;
    text-align: right;
    margin-top: 12px;
    font-weight: 600;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.gray[600]};

    b {
      font-weight: 600;
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.gray[800]};
      margin-left: 5px;
    }

    .discount-info {
      font-weight: 500;
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.gray[500]};

      span {
        display: block;
        margin-bottom: 10px;
      }
    }
  }
`

export default StyledCart
